import { render, staticRenderFns } from "./hospital-form.vue?vue&type=template&id=8dcbcd0e&"
import script from "./hospital-form.vue?vue&type=script&lang=js&"
export * from "./hospital-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports